<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف آواتار
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی آواتار
          <i class="far fa-save"/>
          </span>
          <span v-else>
            ذخیره آواتار جدید
                <i class="fas fa-plus"/>
          </span>
        </button>

        <hr>
      </div>
      <div class="col-12">

        <div class="row">
          <div class="col-12">
            <card class="card" title="اطلاعات پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="name">نام</label>
                      <input id="name" type="text" class="form-control" placeholder="نام"
                             v-model="item.name">
                    </div>
                  </div>

                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="username">ترتیب</label>
                      <input id="username" type="number" class="form-control" placeholder="ترتیب"
                             v-model.number="item.order">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-center">
                      <label for="enable">فعال</label>
                      <fv-switch id="enable" class="form-control d-block mx-auto" placeholder="فعال"
                                 v-model="item.enabled"/>
                    </div>
                  </div>
                </div>
                <div class="clearfix"/>

              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="مدیا">
              <div>
                <div class="form-row">
                  <div class="col-12 mb-3">
                    <div class="form-group text-right">
                      <label for="picture">عکس</label>
                      <appFileUploader id="picture" v-model="mediaObj"/>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Modela from 'modela'
  import avatarModel from "../../models/avatar"
  import {mapActions} from "vuex"
  import appFileUploader from "../../components/appFileUploader";
  import versionModel from "../../models/versions";

  export default {
    name: 'avatar_edit',
    components: {
      appFileUploader,
    },
    data() {
      const {params} = this.$route
      const {id} = params
      return {
        ...mapActions('main', [
          'crud'
        ]),
        id,
        item: {},
      }
    },
    computed: {
      mediaObj: {
        get() {
          const data = {path: this.item.path, type: this.item.type, default: true}
          return data
        },
        set(value) {
          if (value.type && value.path) {
            this.item.type = value.type
            this.item.path = value.path
          } else {
            this.item.type = undefined
            this.item.path = undefined
          }
        }
      }
    },
    methods: {
      async getData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const avatars = await this.crud({
            action: 'get',
            section: 'avatars',
            id: this.id,
            showError: true
          })
          if (avatars.data) {
            const result = avatars.data
            let item = new Modela(avatarModel)
            item = item.$clean()
            item = item.$set(result)
            this.item = item.$clean().$export()
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async post() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const newAvatar = await this.crud({
            action: 'post',
            section: 'avatars',
            data: this.item,
            showError: true
          })
          await this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'avatars'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async put() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const updateAvatar = await this.crud({
            action: 'put',
            section: 'avatars',
            id: this.id,
            data: this.item,
            showError: true
          })
          await this.$successAlert()
          this.$router.go(-1)
          // await this.$router.push({name: 'avatars'})
        } catch (e) {
          console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async del() {
        if (!await this.$confirmAlert())
          return false
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const deleted = await this.crud({
            action: 'delete',
            section: 'avatars',
            id: this.id,
            showError: true
          })
          await this.$successAlert()
          // await this.$router.push({name: 'avatars'})
          this.$router.go(-1)
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async submit() {
        if (this.id !== 'new')
          this.put()
        else
          this.post()
      }
    },
    async created() {
      if (this.id !== 'new')
        await this.getData()
      else {
        let item = new Modela(avatarModel)
        this.item = item.$clean().$export()
      }
    }
  };
</script>
<style>
</style>
